import ViewScheduledPowerConsumersSortedByEnergyRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/view-scheduled-power-consumers-sorted-by-energy-request-dto";
import IViewSpaceClusterHistoricalDataRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/view-space-cluster-historical-data-request-dto";
import ICheckSpaceClusterAvailabilityResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/check-space-cluster-availability-response-dto";
import {
  SpaceClustersResponseDTO,
  ViewConsumedSpaceClusterByYearAndMonthResponseDTO,
  ViewSpaceClusterConsumptionByYearAndMonthResponseDTO,
  ViewSpaceClusterEnergyWithComparisonResponseDTO,
} from "../../../shared/oversight-core/dtos/response-dtos/dashboard-api-dto";
import ViewScheduledPowerConsumersSortedByEnergyResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-scheduled-power-consumers-sorted-by-energy-response-dto";
import IViewSpaceClusterHistoricalDataResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-space-cluster-historical-data-response-dto";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export const dashboardAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getSpaceClustersXY: builder.query<SpaceClustersResponseDTO, void>({
      transformErrorResponse,
      query() {
        return {
          url: `space-cluster/with-power-generators/list`,
          method: "GET",
        };
      },
    }),
    getSpaceClusterEnergyWithComparison: builder.query<
      ViewSpaceClusterEnergyWithComparisonResponseDTO,
      { spaceClusterId: string; zoneOffset: string }
    >({
      transformErrorResponse,
      query({ spaceClusterId, zoneOffset }) {
        return {
          url: `space-cluster/${spaceClusterId}/energy/with-comparison/view`,
          method: "GET",
          params: {
            zoneOffset,
          },
        };
      },
    }),
    getConsumedSpaceClusterByYearAndMonth: builder.query<
      ViewConsumedSpaceClusterByYearAndMonthResponseDTO,
      { spaceClusterId: string; year: number; month: number }
    >({
      transformErrorResponse,
      query({ spaceClusterId, year, month }) {
        return {
          url: `space-cluster/${spaceClusterId}/consumed-energy/by-year-month/view`,
          method: "GET",
          params: { year, month },
        };
      },
    }),
    viewPowerConsumersWithHighConsumption: builder.query<
      ViewScheduledPowerConsumersSortedByEnergyResponseDTO,
      ViewScheduledPowerConsumersSortedByEnergyRequestDTO
    >({
      transformErrorResponse,
      query({
        clusterId,
        sortingOrder,
        limit,
        viewType,
        energyViewType,
        year,
        month,
        zoneOffset,
      }) {
        return {
          url: `space-cluster/${clusterId}/power-consumer-usage-schedule/sort-by-energy/view`,
          method: "GET",
          params: {
            sortingOrder,
            limit,
            viewType,
            energyViewType,
            year,
            month,
            zoneOffset,
          },
        };
      },
    }),
    viewSpaceClusterConsumptionByYearAndMonth: builder.query<
      ViewSpaceClusterConsumptionByYearAndMonthResponseDTO,
      { spaceClusterId: string; year: number; month: number }
    >({
      transformErrorResponse,
      query({ spaceClusterId, year, month }) {
        return {
          url: `space-cluster/${spaceClusterId}/consumption/by-year-month/view`,
          method: "GET",
          params: { year, month },
        };
      },
    }),
    checkSpaceClusterAvailability: builder.query<
      ICheckSpaceClusterAvailabilityResponseDTO,
      {
        spaceClusterId: string;
        spaceId?: string;
        zoneOffset: string;
      }
    >({
      transformErrorResponse,
      query({ spaceClusterId, spaceId, zoneOffset }) {
        return {
          url: `space-cluster/${spaceClusterId}/availability`,
          method: "GET",
          params: {
            spaceId,
            zoneOffset,
          },
        };
      },
    }),
    viewSpaceClusterHistoricalData: builder.query<
      IViewSpaceClusterHistoricalDataResponseDTO,
      IViewSpaceClusterHistoricalDataRequestDTO
    >({
      transformErrorResponse,
      query({ spaceClusterId, year, month, zoneOffset, usageDataFrom }) {
        return {
          url: `space-cluster/${spaceClusterId}/historical-data/view`,
          method: "GET",
          params: {
            year,
            month,
            zoneOffset,
            usageDataFrom,
          },
        };
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useLazyGetSpaceClustersXYQuery,
  useLazyGetSpaceClusterEnergyWithComparisonQuery,
  useLazyGetConsumedSpaceClusterByYearAndMonthQuery,
  useLazyViewPowerConsumersWithHighConsumptionQuery,
  useLazyViewSpaceClusterConsumptionByYearAndMonthQuery,
  useLazyCheckSpaceClusterAvailabilityQuery,
  useLazyViewSpaceClusterHistoricalDataQuery,
} = dashboardAPI;
